import { firebaseStorage, } from '../dataBase/firebase';
//import { app, storage, } from '../dataBase/firebase';
//import firebase from 'firebase';
//import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/storage';

import { isUndNullEmp, responseGet, } from '../../helpers/settings';
//import { isEmpty, isNull, isUndefined, map } from 'lodash';

//const db = firebase.firestore(firebaseApp);
//const db = firebase.firestore(firebaseApp);
//const db = firebase.firestore(app);

//#region Users
//#region old code
// export const closeSession = () => {
//     firebase.auth().signOut();
// }
//#endregion old code

//#region old code
// export const createUserWithEmailAndPasswordAsync = async (email, password) => {
//     let response = responseGet();
//     try {
//         response.result = await firebase.auth().createUserWithEmailAndPassword(email, password);
//     } catch (ex) {
//         switch (ex.code) {
//             case 'auth/email-already-in-use':
//                 response.isWarning = true;
//                 response.msgType = 1;
//                 response.msgText = globalSettings?.messages?.theEmailAlreadyByAnotherAccount.en;
//                 break;
//             default:
//                 response.isSuccess = false;
//                 response.msgType = -1;
//                 response.msgText = `Method: createUserWithEmailAndPasswordAsync</br>${ex?.message}`;
//                 break
//         }
//     }
//     return response;
// }
//#endregion old code

//#region old code
// export const deleteCurrentUserAsync = async () => {
//     let response = responseGet();
//     try {
//         const currentUser = getCurrentUser();
//         await currentUser.delete();
//     } catch (ex) {
//         response.isSuccess = false;
//         response.msgType = -1;
//         response.msgText = `Method: deleteCurrentUserAsync</br>${ex?.message}`;
//     }
//     return response;
// }
//#endregion old code

//#region old code
// export const getCurrentUser = () => {
//     return firebase.auth().currentUser;
// }
//#endregion old code

//#region old code
// export const resetPasswordAsync = async (email) => {
//     let response = responseGet();
//     try {
//         response.result = await firebaseApp.auth().sendPasswordResetEmail(email);
//         response.msgText = globalSettings?.messages?.theInstructionsPasswordRecoveryWereSentEmail;
//     } catch (ex) {
//         switch (ex.code) {
//             case 'auth/user-not-found':
//                 response.isSuccess = true;
//                 response.isWarning = true;
//                 response.msgType = 1;
//                 response.msgText = `${globalSettings?.messages?.thisUserDoesNotExist.es}`;
//                 break;

//             default:
//                 response.isSuccess = false;
//                 response.msgType = -1;
//                 response.msgText = `Method: resetPasswordAsync<br/>${ex?.message}.`;
//                 break;
//         }
//     }
//     return response;
// }
//#endregion old code

//#region old code
// export const sendEmailVerificationAsync = async () => {
//     let response = responseGet();
//     try {
//         const user = getCurrentUser()
//         await user.sendEmailVerification();
//     } catch (ex) {
//         response.isSuccess = false;
//         response.msgType = -1;
//         response.msgText = `Method: sendEmailVerificationAsync</br>`;
//         response.msgText += `Error: ${ex?.message}`;
//     }
//     return response;
// }
//#endregion old code

//#region old code
// export const updateUserAsync = async (newUser) => {
//     let response = responseGet();
//     try {
//         const user = getCurrentUser();
//         const newUserData = {
//             displayName: `${newUser.firstName}, ${newUser.lastName}`,
//             photoURL: newUser.photoURL,
//             //phoneNumber: newUser.phones,
//         };
//         await user.updateProfile(newUserData);
//     } catch (ex) {
//         response.isSuccess = false;
//         response.msgType = -1;
//         response.msgText = `Method: updateUserAsync</br>`;
//         response.msgText += `Error: ${ex?.message}`;
//     }
//     return response;
// }
//#endregion old code
//#endregion Users

//#region documents
//#region old code
// export const addDocumentAsync = async (collection, data) => {
//     let response = responseGet();
//     try {
//         const result = await db.collection(collection).add(data);
//         data.id = result.id;
//         response.result = data;

//     } catch (ex) {
//         response.isSuccess = false;
//         response.msgType = -1;
//         response.msgText = `Method: addDocumentAsync\n${ex?.message}`;
//     }
//     return response;
// }
//#endregion old code

//#region old code
// export const addDocumentWithIdAsync = async (collection, id, data) => {
//     let response = responseGet();
//     try {
//         await db.collection(collection).doc(id).set(data);
//     } catch (ex) {
//         response.isSuccess = false;
//         response.msgType = -1;
//         response.msgText = `Method: addDocumentWithIdAsync\n${ex?.message}`;
//     }
//     return response;
// }
//#endregion old code

//#region old code
// export const deleteDocumentByIdAsync = async (collection, id) => {
//     let response = responseGet();
//     try {
//         await db.collection(collection).doc(id).delete();
//     } catch (ex) {
//         response.isSuccess = false;
//         response.msgType = -1;
//         response.msgText = `Method: deleteDocumentByIdAsync\n${ex?.message}`;
//     }
//     return response;
// }
//#endregion old code

//#region old code
// export const getCollectionsOrderByAsync = async (collection, orderByField, orderByValue) => {
//     let response = responseGet();
//     try {
//         // const result = await db
//         // .collection(collection)
//         // .orderBy(orderByField, orderByValue)
//         // .get();

//         let firebaseQuery = db.collection(collection);
//         if (!isUndefined(orderByField) && !isNull(orderByField) && !isEmpty(orderByField) &&
//             !isUndefined(orderByValue) && !isNull(orderByValue) && !isEmpty(orderByValue)) {
//             firebaseQuery = firebaseQuery.orderBy(orderByField, orderByValue);
//         } else if (!isUndefined(orderByField) && !isNull(orderByField) && !isEmpty(orderByField)) {
//             firebaseQuery = firebaseQuery.orderBy(orderByField);
//         }
//         const result = await firebaseQuery.get();
//         response.result = result.docs.map(doc => ({ id: doc.id, ...doc.data() }));
//     } catch (ex) {
//         response.isSuccess = false;
//         response.msgType = -1;
//         response.msgText = `Method: getCollectionsOrderByAsync\n${ex?.message}`;
//     }
//     return response;
// }
//#endregion old code

//#region old code
// export const getDocumentByIdAsync = async (collection, id) => {
//     let response = responseGet();
//     try {
//         const result = await db.collection(collection).doc(id).get();
//         //response.result = {id: result.id, ...result.data(), };
//         if (result.data() != null) {
//             response.result = { id: result.id, ...result.data(), };
//         };
//     } catch (ex) {
//         response.isSuccess = false;
//         response.msgType = -1;
//         response.msgText = `Method: getDocumentByIdAsync\n${ex?.message}`;
//     }
//     return response;
// }
//#endregion old code

//#region old code
// export const getDocumentByConditionalsAsync = async (collection, conditionals, ordersBy, limit) => {
//     let response = responseGet();
//     try {
//         let firebaseQuery = db.collection(collection);

//         // Conditionals
//         map(conditionals, (conditionl, index) => {
//             firebaseQuery = firebaseQuery.where(conditionl.field, conditionl.operator, conditionl.value);
//         });

//         // Order by
//         map(ordersBy, (orderBy, index) => {
//             if (orderBy.field !== '' && orderBy.value !== '') {
//                 firebaseQuery = firebaseQuery.orderBy(orderBy.field, orderBy.value);
//             } else {
//                 firebaseQuery = firebaseQuery.orderBy(orderBy.field);
//             }
//         });

//         // Limits
//         if (limit > 0) {
//             firebaseQuery = firebaseQuery.limit(limit);
//         }

//         const result = await firebaseQuery.get();
//         response.result = result.docs.map(doc => ({ id: doc.id, ...doc.data() }));
//     } catch (ex) {
//         response.isSuccess = false;
//         response.msgType = -1;
//         response.msgText = `Method: getDocumentByConditionalsAsync\n${ex?.message}`;
//     }
//     return response;
// }
//#endregion old code

//#region old code
// export const updateDocumentByIdAsync = async (collection, id, data) => {
//     let response = responseGet();
//     try {
//         await db.collection(collection).doc(id).update(data);
//     } catch (ex) {
//         response.isSuccess = false;
//         response.msgType = -1;
//         response.msgText = `Method: updateDocumentByIdAsync\n${ex?.message}`;
//     }
//     return response;
// }
//#endregion old code
//#endregion documents

//#region Files
export const fileUploadAsync = async ({ folder = '', file = {}, fileName = '', languageId = 'en', subMethod = '', }) => {
    const currentMethod = 'fileUploadAsync';
    let response = responseGet();
    try {
        const uploadTask = firebaseStorage?.ref(folder)?.child(fileName);
        await uploadTask?.put(file);
        response.result = await firebaseStorage?.ref(`${folder}/${fileName}`)?.getDownloadURL();
    } catch (ex) {
        response.msgType = -1;
        response.isSuccess = false;
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            response.msgText += `Sub method: ${subMethod}<br/>`;
        }
        response.msgText += `Error: ${ex?.message}`;
    }
    return response;
}

//#region old code

// export const fileDeleteAsync = async (folder, fileName) => {
//     let response = responseGet();
//     try {
//         //const deleteTask = firebaseStorage.ref(folder).child(fileName);
//         //response.result = await deleteTask.delete();
//         //response = await fileDownloadUrlGetAsync(folder, fileName);

//         response.result = await firebaseStorage.ref(folder).child(fileName).delete();
//     } catch (ex) {
//         //response.isSuccess = false;
//         //response.msgType = -1;
//         response.msgText = `Method: fileDeleteAsync<br/>`;
//         response.msgText += `Error: ${ex?.message}`;
//         if (response.msgText.indexOf('does not exist. (storage/object-not-found)') >= 0) {
//             //response.isWarning = true;
//             //response.msgType = 1;
//             response.msgText = `${globalSettings?.messages?.theFileCannotBeLocated.es}<br/>`;
//             response.msgText += `${globalSettings?.labels?.folder.es}: <b>${folder}</b><br/>`;
//             response.msgText += `${globalSettings?.labels?.file.es}: <b>${fileName}</b>`;
//         }
//         else if (response.msgText.indexOf("The path may not end with '/' or contain two consecutive '/'s") >= 0) {
//             //response.isWarning = true;
//             //response.msgType = 1;
//             response.msgText = `${globalSettings?.messages?.theFileCannotBeLocated.es}<br/>`;
//             response.msgText += `${globalSettings?.labels?.folder.es}: <b>${folder}</b><br/>`;
//             response.msgText += `${globalSettings?.labels?.file.es}: <b>${fileName}</b>`;
//         } else {
//             response.isSuccess = false;
//             response.msgType = -1;
//         }
//     }
//     return response;
// }

//#endregion old code

//#region old code
// export const fileDownloadUrlGetAsync = async (folder, fileName) => {
//     let response = responseGet();
//     try {
//         //firebaseStorage.ref(folder).child(fileName);
//         response.result = await firebaseStorage.ref(`${folder}/${fileName}`).getDownloadURL();
//     } catch (ex) {
//         response.msgText = `Method: fileDownloadUrlGetAsync<br/>`;
//         response.msgText += `Error: ${ex?.message}`;
//         if (response.msgText.indexOf('does not exist. (storage/object-not-found)') >= 0) {
//             response.isWarning = true;
//             response.msgType = 1;
//             response.msgText = `${globalSettings?.messages?.theFileCannotBeLocated.es}<br/>`;
//             response.msgText += `${globalSettings?.labels?.folder.es}: <b>${folder}</b><br/>`;
//             response.msgText += `${globalSettings?.labels?.file.es}: <b>${fileName}</b>`;
//             // } else if (response.msgText.indexOf("The path may not end with '/' or contain two consecutive '/'s") >= 0) {
//             //     //response.isWarning = true;
//             //     //response.msgType = 1;
//             //     response.msgText = `${globalSettings?.messages?.theFileCannotBeLocated.es}<br/>`;
//             //     response.msgText += `${globalSettings?.labels?.folder.es}: <b>${folder}</b><br/>`;
//             //     response.msgText += `${globalSettings?.labels?.file.es}: <b>${fileName}</b>`;
//         } else {
//             response.isSuccess = false;
//             response.msgType = -1;
//         }
//     }
//     return response;
// }
//#endregion old code
//#endregion Files